// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Checkout Page Styles */

/* Order Summary Card */
.order-summary-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.4rem;
  padding: 0.2rem 0;
}

.order-summary-text span:first-child {
  flex: 1 1;
  text-align: left;
  font-weight: 500;
  color: #586069;
  font-size: 0.9rem;
}

.order-summary-text span:last-child {
  flex: 0 0 auto;
  text-align: right;
  min-width: 90px;
  font-weight: 600;
  color: #24292e;
  font-size: 0.9rem;
}

/* Items list in Order Summary */
.order-items-summary {
  padding-right: 8px;
  max-height: 320px;
  overflow-y: auto;
}

.order-items-summary .item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.6rem;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #e1e4e8;
}

.order-items-summary .item-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.order-items-summary .item-details {
  flex: 1 1;
  padding-right: 0.75rem;
  min-width: 0;
}

.order-items-summary .item-name {
  font-size: 0.85rem;
  color: #24292e;
  margin-bottom: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 25ch;
  font-weight: 500;
}

.order-items-summary .item-quantity {
  font-size: 0.75rem;
  color: #6c757d;
}

.order-items-summary .item-price {
  flex: 0 0 auto;
  text-align: right;
  min-width: 75px;
  font-weight: 600;
  color: #24292e;
  font-size: 0.85rem;
}

/* Totals Section */
.checkout-totals {
  padding-top: 0.75rem;
  border-top: 1px solid #e1e4e8;
}

.checkout-totals .total-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.checkout-totals .total-line span:first-child {
  color: #586069;
  font-weight: 500;
}

.checkout-totals .total-line span:last-child {
  text-align: right;
  min-width: 90px;
  font-weight: 600;
  color: #24292e;
}

.checkout-totals .total-line.total-final {
  font-size: 1.05rem;
  padding-top: 0.5rem;
  border-top: 2px solid #24292e;
  margin-top: 0.5rem;
}

.checkout-totals .total-line.total-final strong {
  color: #24292e;
  font-weight: 700;
}

.checkout-totals .total-line.total-final .text-primary {
  font-size: 1.1rem;
  color: #0066cc !important;
  font-weight: 700;
}

/* Tax calculation status */
.tax-status {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.tax-status .badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

/* Payment Method Section */
.payment-method-card {
  border: 1px solid #e1e4e8;
  transition: all 0.2s ease;
  border-radius: 6px;
}

.payment-method-card:hover {
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  border-color: #d1d5da;
}

/* Payment Method Radio Options */
.payment-method-container {
  padding: 1rem;
}

.form-check.payment-option {
  padding: 0.875rem;
  background: #fafbfc;
  border-radius: 6px;
  margin-bottom: 0.75rem;
  border: 1.5px solid #e1e4e8;
  transition: all 0.2s ease;
}

.form-check.payment-option:hover {
  background: #f6f8fa;
  border-color: #c8d1d9;
}

.form-check.payment-option.selected {
  background: #f0f7ff;
  border-color: #0066cc;
  box-shadow: 0 0 0 1px rgba(0, 102, 204, 0.1);
}

.form-check-input[type="radio"] {
  display: none;
}

.form-check-label {
  width: 100%;
  padding-left: 0;
  cursor: pointer;
}

.payment-method-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #212529;
}

.payment-method-subtitle {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  padding-left: 1.75rem;
}

.payment-badges {
  display: flex;
  gap: 0.5rem;
  padding-left: 1.75rem;
  margin-top: 0.75rem;
}

.payment-badges .badge {
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 4px;
}

.payment-badges .badge.bg-success {
  background: #28a745 !important;
}

.payment-badges .badge.bg-primary {
  background: #0066cc !important;
}

.payment-badges .badge.bg-info {
  background: #17a2b8 !important;
  color: white !important;
}

/* Payment Info Alert */
.payment-info-alert {
  background: #f0f7ff;
  border: 1px solid #c8e1ff;
  border-radius: 6px;
  padding: 0.875rem;
  margin-top: 0.75rem;
}

.payment-info-alert .alert-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 600;
  color: #0366d6;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.payment-info-alert .alert-text {
  color: #0366d6;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  padding-left: 1.25rem;
  line-height: 1.4;
}

.payment-info-alert ul {
  margin: 0;
  padding-left: 2.25rem;
  color: #0366d6;
}

.payment-info-alert ul li {
  margin-bottom: 0.2rem;
  font-size: 0.8rem;
  line-height: 1.4;
}

/* Address Cards */
.address-card {
  min-height: 450px;
}

.address-card.billing-same {
  min-height: 200px;
}

.address-validation-status {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

/* Buttons */
.checkout-button {
  width: 100%;
  padding: 0.625rem;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 4px;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.checkout-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0,0,0,0.12);
}

.checkout-button.btn-primary {
  background: #0066cc;
  border: 1px solid #0066cc;
  color: white;
}

.checkout-button.btn-primary:hover:not(:disabled) {
  background: #0052a3;
  border-color: #0052a3;
}

.checkout-button.btn-secondary {
  background: #6c757d;
  border: 1px solid #6c757d;
  color: white;
}

.checkout-button.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
  border-color: #5a6268;
}

/* Responsive adjustments */
@media (max-width: 991px) {
  .order-summary-text span:last-child,
  .checkout-totals .total-line span:last-child {
    min-width: 80px;
  }

  .order-items-summary .item-price {
    min-width: 70px;
  }
}

@media (max-width: 576px) {
  .order-summary-text,
  .checkout-totals .total-line {
    font-size: 0.9rem;
  }

  .checkout-totals .total-line.total-final {
    font-size: 1rem;
  }

  .checkout-totals .total-line.total-final .text-primary {
    font-size: 1.1rem;
  }
}

/* Scrollbar styling for order items */
.order-items-summary::-webkit-scrollbar {
  width: 6px;
}

.order-items-summary::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.order-items-summary::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.order-items-summary::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Alert styling */
.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

/* Form labels */
.form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

/* Card headers */
.card-header {
  padding: 0.875rem 1rem;
  font-weight: 600;
  background: #f6f8fa;
  border-bottom: 1px solid #e1e4e8;
}

.card-header.bg-primary {
  background: #0066cc !important;
  color: white;
}

.card-header h5 {
  font-size: 1rem;
  margin: 0;
  font-weight: 600;
}

/* Ensure proper spacing */
.container.mt-4 {
  padding-bottom: 2rem;
}

/* Fix text alignment in forms */
.form-control {
  text-align: left;
}

.form-check-label {
  margin-left: 0.25rem;
  cursor: pointer;
}

/* Lighter placeholder text - same color as form labels */
.form-control::placeholder {
  color: #9ca3af;
  opacity: 1;
  font-weight: 400;
}

.form-control::-webkit-input-placeholder {
  color: #9ca3af;
  opacity: 1;
  font-weight: 400;
}

.form-control::-moz-placeholder {
  color: #9ca3af;
  opacity: 1;
  font-weight: 400;
}

.form-control:-ms-input-placeholder {
  color: #9ca3af;
  opacity: 1;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/Checkout.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["/* Checkout Page Styles */\n\n/* Order Summary Card */\n.order-summary-text {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.4rem;\n  padding: 0.2rem 0;\n}\n\n.order-summary-text span:first-child {\n  flex: 1;\n  text-align: left;\n  font-weight: 500;\n  color: #586069;\n  font-size: 0.9rem;\n}\n\n.order-summary-text span:last-child {\n  flex: 0 0 auto;\n  text-align: right;\n  min-width: 90px;\n  font-weight: 600;\n  color: #24292e;\n  font-size: 0.9rem;\n}\n\n/* Items list in Order Summary */\n.order-items-summary {\n  padding-right: 8px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.order-items-summary .item-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.6rem;\n  padding-bottom: 0.6rem;\n  border-bottom: 1px solid #e1e4e8;\n}\n\n.order-items-summary .item-row:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.order-items-summary .item-details {\n  flex: 1;\n  padding-right: 0.75rem;\n  min-width: 0;\n}\n\n.order-items-summary .item-name {\n  font-size: 0.85rem;\n  color: #24292e;\n  margin-bottom: 0.2rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 25ch;\n  font-weight: 500;\n}\n\n.order-items-summary .item-quantity {\n  font-size: 0.75rem;\n  color: #6c757d;\n}\n\n.order-items-summary .item-price {\n  flex: 0 0 auto;\n  text-align: right;\n  min-width: 75px;\n  font-weight: 600;\n  color: #24292e;\n  font-size: 0.85rem;\n}\n\n/* Totals Section */\n.checkout-totals {\n  padding-top: 0.75rem;\n  border-top: 1px solid #e1e4e8;\n}\n\n.checkout-totals .total-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.checkout-totals .total-line span:first-child {\n  color: #586069;\n  font-weight: 500;\n}\n\n.checkout-totals .total-line span:last-child {\n  text-align: right;\n  min-width: 90px;\n  font-weight: 600;\n  color: #24292e;\n}\n\n.checkout-totals .total-line.total-final {\n  font-size: 1.05rem;\n  padding-top: 0.5rem;\n  border-top: 2px solid #24292e;\n  margin-top: 0.5rem;\n}\n\n.checkout-totals .total-line.total-final strong {\n  color: #24292e;\n  font-weight: 700;\n}\n\n.checkout-totals .total-line.total-final .text-primary {\n  font-size: 1.1rem;\n  color: #0066cc !important;\n  font-weight: 700;\n}\n\n/* Tax calculation status */\n.tax-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.tax-status .badge {\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n}\n\n/* Payment Method Section */\n.payment-method-card {\n  border: 1px solid #e1e4e8;\n  transition: all 0.2s ease;\n  border-radius: 6px;\n}\n\n.payment-method-card:hover {\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\n  border-color: #d1d5da;\n}\n\n/* Payment Method Radio Options */\n.payment-method-container {\n  padding: 1rem;\n}\n\n.form-check.payment-option {\n  padding: 0.875rem;\n  background: #fafbfc;\n  border-radius: 6px;\n  margin-bottom: 0.75rem;\n  border: 1.5px solid #e1e4e8;\n  transition: all 0.2s ease;\n}\n\n.form-check.payment-option:hover {\n  background: #f6f8fa;\n  border-color: #c8d1d9;\n}\n\n.form-check.payment-option.selected {\n  background: #f0f7ff;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 1px rgba(0, 102, 204, 0.1);\n}\n\n.form-check-input[type=\"radio\"] {\n  display: none;\n}\n\n.form-check-label {\n  width: 100%;\n  padding-left: 0;\n  cursor: pointer;\n}\n\n.payment-method-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #212529;\n}\n\n.payment-method-subtitle {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n  padding-left: 1.75rem;\n}\n\n.payment-badges {\n  display: flex;\n  gap: 0.5rem;\n  padding-left: 1.75rem;\n  margin-top: 0.75rem;\n}\n\n.payment-badges .badge {\n  padding: 0.35rem 0.65rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 4px;\n}\n\n.payment-badges .badge.bg-success {\n  background: #28a745 !important;\n}\n\n.payment-badges .badge.bg-primary {\n  background: #0066cc !important;\n}\n\n.payment-badges .badge.bg-info {\n  background: #17a2b8 !important;\n  color: white !important;\n}\n\n/* Payment Info Alert */\n.payment-info-alert {\n  background: #f0f7ff;\n  border: 1px solid #c8e1ff;\n  border-radius: 6px;\n  padding: 0.875rem;\n  margin-top: 0.75rem;\n}\n\n.payment-info-alert .alert-title {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-weight: 600;\n  color: #0366d6;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.payment-info-alert .alert-text {\n  color: #0366d6;\n  font-size: 0.8rem;\n  margin-bottom: 0.5rem;\n  padding-left: 1.25rem;\n  line-height: 1.4;\n}\n\n.payment-info-alert ul {\n  margin: 0;\n  padding-left: 2.25rem;\n  color: #0366d6;\n}\n\n.payment-info-alert ul li {\n  margin-bottom: 0.2rem;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n/* Address Cards */\n.address-card {\n  min-height: 450px;\n}\n\n.address-card.billing-same {\n  min-height: 200px;\n}\n\n.address-validation-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Buttons */\n.checkout-button {\n  width: 100%;\n  padding: 0.625rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.checkout-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 3px 8px rgba(0,0,0,0.12);\n}\n\n.checkout-button.btn-primary {\n  background: #0066cc;\n  border: 1px solid #0066cc;\n  color: white;\n}\n\n.checkout-button.btn-primary:hover:not(:disabled) {\n  background: #0052a3;\n  border-color: #0052a3;\n}\n\n.checkout-button.btn-secondary {\n  background: #6c757d;\n  border: 1px solid #6c757d;\n  color: white;\n}\n\n.checkout-button.btn-secondary:hover:not(:disabled) {\n  background: #5a6268;\n  border-color: #5a6268;\n}\n\n/* Responsive adjustments */\n@media (max-width: 991px) {\n  .order-summary-text span:last-child,\n  .checkout-totals .total-line span:last-child {\n    min-width: 80px;\n  }\n\n  .order-items-summary .item-price {\n    min-width: 70px;\n  }\n}\n\n@media (max-width: 576px) {\n  .order-summary-text,\n  .checkout-totals .total-line {\n    font-size: 0.9rem;\n  }\n\n  .checkout-totals .total-line.total-final {\n    font-size: 1rem;\n  }\n\n  .checkout-totals .total-line.total-final .text-primary {\n    font-size: 1.1rem;\n  }\n}\n\n/* Scrollbar styling for order items */\n.order-items-summary::-webkit-scrollbar {\n  width: 6px;\n}\n\n.order-items-summary::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.order-items-summary::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 3px;\n}\n\n.order-items-summary::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Alert styling */\n.alert-info {\n  background-color: #d1ecf1;\n  border-color: #bee5eb;\n  color: #0c5460;\n}\n\n.alert-warning {\n  background-color: #fff3cd;\n  border-color: #ffeaa7;\n  color: #856404;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n  color: #721c24;\n}\n\n/* Form labels */\n.form-label {\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n/* Card headers */\n.card-header {\n  padding: 0.875rem 1rem;\n  font-weight: 600;\n  background: #f6f8fa;\n  border-bottom: 1px solid #e1e4e8;\n}\n\n.card-header.bg-primary {\n  background: #0066cc !important;\n  color: white;\n}\n\n.card-header h5 {\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 600;\n}\n\n/* Ensure proper spacing */\n.container.mt-4 {\n  padding-bottom: 2rem;\n}\n\n/* Fix text alignment in forms */\n.form-control {\n  text-align: left;\n}\n\n.form-check-label {\n  margin-left: 0.25rem;\n  cursor: pointer;\n}\n\n/* Lighter placeholder text - same color as form labels */\n.form-control::placeholder {\n  color: #9ca3af;\n  opacity: 1;\n  font-weight: 400;\n}\n\n.form-control::-webkit-input-placeholder {\n  color: #9ca3af;\n  opacity: 1;\n  font-weight: 400;\n}\n\n.form-control::-moz-placeholder {\n  color: #9ca3af;\n  opacity: 1;\n  font-weight: 400;\n}\n\n.form-control:-ms-input-placeholder {\n  color: #9ca3af;\n  opacity: 1;\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
